import { render, staticRenderFns } from "./WarehousePeriodicStockReportDashboard.vue?vue&type=template&id=ee088a74&"
import script from "./WarehousePeriodicStockReportDashboard.vue?vue&type=script&lang=js&"
export * from "./WarehousePeriodicStockReportDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports